import { Grid } from "@mui/material";
import React from "react";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { AddButton } from "../bankDetails/components/bankAccountsContent";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import InvoiceModuleTableContent from "./components/invoiceModuleTableContent";

function InvoiceModuleTable() {
  return (
    <div>
      <TitleHolder style={{ paddingBottom: "0" }}>
        <Grid container spacing={1}>
          <Grid sx={{ whiteSpace: "nowrap" }} item xs={6}>
            Invoices
          </Grid>
          <Grid item xs={6}>
            <div style={{ textAlign: "right" }}>
              <AddButton replace to="/app/invoices"></AddButton>
            </div>
          </Grid>
        </Grid>
      </TitleHolder>
      <br />
      <StepperContentHolder>
        <InvoiceModuleTableContent />
      </StepperContentHolder>
    </div>
  );
}

export default InvoiceModuleTable;
